module.exports = __webpack_public_path__ + "static/media/Flaticon.3fbe7ae3.ttf";